import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { VEHICLE_BUY_IN_RESOURCE } from "./use-vehicle-buy-in-create-data.query";

export const VEHICLE_BUY_IN_SYNC_V1_GEWA_API_PATH = "/v1/vehicle-buy-in/{uuid}/sync-v1-gewa" as const;

export type VehicleBuyInSyncV1GewaResponse =
  paths[typeof VEHICLE_BUY_IN_SYNC_V1_GEWA_API_PATH]["post"]["responses"][201]["content"]["application/json"];

export function useVehicleBuyInSyncV1GewaMutation() {
  const queryClient = useQueryClient();

  return useMutation<VehicleBuyInSyncV1GewaResponse, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      const apiPath = VEHICLE_BUY_IN_SYNC_V1_GEWA_API_PATH.replace("{uuid}", uuid);
      const response = await alphartisApiAxios.post<VehicleBuyInSyncV1GewaResponse>(apiPath);
      return response.data;
    },
    onSettled: async (_data, _error, { uuid }) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [VEHICLE_BUY_IN_RESOURCE, uuid],
          refetchType: "all",
        }),
        queryClient.invalidateQueries({
          queryKey: [VEHICLE_BUY_IN_RESOURCE, "search"],
          refetchType: "all",
        }),
      ]);
    },
  });
}
